<template>
  <div class="row hotel-block">
    <div class="col-md-4 col-lg-5 px-md-3 px-0">
      <div class="hotel-slider">
        <b-carousel
          id="carousel-fade"
          class="px-0"
          :interval="3000"
          style="text-shadow: 0px 0px 2px #000"
          fade
          indicators
          img-width="1024"
          img-height="480"
          ><div>
            <a :href="propertyUrl" target="_blank">
              <template v-if="property.media.length">
                <div v-for="item of property.media" :key="item.id">
                  <b-carousel-slide :img-src="item.url"></b-carousel-slide>
                </div>
              </template>
              <template v-else>
                <b-carousel-slide
                  v-for="i of 2"
                  :key="i"
                  img-src="/images/property-default-image.jpg"
                ></b-carousel-slide>
              </template>
            </a>
          </div>
        </b-carousel>
      </div>
    </div>
    <div class="col-md-8 col-lg-7 hotelTxtInner px-md-3 px-0">
      <div class="hotel-txt">
        <div class="hotel-rating row">
          <div class="col-md-8 pt-md-0 px-md-3 px-0 pt-3">
            <p class="d-md-block d-none">{{ property.name }}</p>
            <h4 class="d-flex align-items-baseline">
              <a :href="propertyUrl" target="_blank"
                ><div class="g-text-page">{{ property.name }}</div></a
              >
              <StarRating
                class="ml-2"
                :value="ratingValue(property.ratingValue)"
              />
            </h4>
            <div class="access">
              <li v-if="property.addresses">
                <a
                  :href="`https://www.google.com/maps?q=${property.geoCode.latitude},${property.geoCode.longitude}`"
                  target="_blank"
                  >{{ formatAddressText(property.addresses[0]) }}</a
                >
              </li>
              <li>
                <a
                  :href="`/listing_map?property_id=${property.id}&list_id=${listId}&latitude=${property.geoCode.latitude}&longitude=${property.geoCode.longitude}`"
                  target="_blank"
                  >{{ $t("listing.showOnMap") }}</a
                >
              </li>
              <li>
                <a
                  v-if="property.googleReviews?.googleBusinessPlacesId"
                  target="_blank"
                  :href="`https://www.google.com/maps/search/?api=1&query=Google&query_place_id=${property.googleReviews?.googleBusinessPlacesId}`"
                  >{{ $t("property.showInGoogle") }}
                  <img width="12px" src="../../assets/icons/g.svg" alt=""
                /></a>
              </li>
            </div>
          </div>
          <div
            class="col-md-4 d-flex align-items-baseline justify-content-md-end review mt-md-3"
          >
            <div class="d-flex align-items-center">
              <div class="mr-3">
                <h5 class="text-center">
                  {{
                    getTranslatedRating(parseFloat(property.ratingValue) * 2)
                  }}
                </h5>
                <div v-if="property.ratingCount > 0" class="small">
                  {{ property.ratingCount }}
                  {{ $tc("property.reviewCount", property.ratingCount) }}
                </div>
              </div>
              <span class="rating">{{
                ratingValue(parseFloat(property.ratingValue) * 2)
              }}</span>
            </div>
          </div>
        </div>
        <div
          class="text-danger no-availability py-3"
          v-if="!hidePrice && ['A', 'B'].includes(property.distributorType) && property.availability && property.availability.price <= 0"
        >
          <b-icon icon="exclamation-circle" class="text-danger"></b-icon>
          <span class="ml-2">
            {{
              $t("listing.noAvailability", {
                checkIn: date.checkIn,
                checkOut: date.checkOut,
              })
            }}
          </span>
        </div>
        <div
          class="availability d-flex mt-1 align-items-end"
          :class="{ 'justify-content-between': showDistributorLabels, 'justify-content-end': !showDistributorLabels }"
        >
          <DistributorLabel
            :type="property.distributorType"
            :supplier-id="property.supplierId"
          />
          <div class="text-right">
            <div v-if="!hidePrice && ['A', 'B'].includes(property.distributorType) && property.availability" class="text-right availability">
              <template v-if="property.availability.price > 0">
                <div class="review-count">
                  {{
                    $tc("listing.nightCount", nbOfNights, {
                      count: nbOfNights,
                    })
                  }}
                </div>
                <h5 class="font-weight-bold">
                  <small class="from-text">{{ $t("listing.from") }}</small>
                  {{ property.availability.currency }}
                  {{ property.availability.price | formatPrice }}
                </h5>
              </template>
            </div>
            <a
              :href="propertyUrl"
              target="_blank"
              @click="openProperty(property.id)"
              class="btn g-primary-button"
              >{{ $t("listing.viewDetails") }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import StarRating from "../Widgets/StarRating.vue";
import DistributorLabel from "./DistributorLabel.vue";
import { formatAddressText } from "../../helpers";
import { currentConfigKey } from "@/helpers/theme";
export default {
  name: "PropertyCard",
  props: {
    property: {
      type: Object,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
    date: {
      type: Object,
      required: true,
    },
    destination: String,
    propertyUrl: String,
    hidePrice: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      listId: null,
    };
  },
  components: {
    StarRating,
    DistributorLabel,
  },
  created() {
    this.listId = this.bookingEngineId;
  },
  computed: {
    ...mapGetters("config", ["bookingEngineId"]),
    showDistributorLabels() {
      return currentConfigKey("showDistributorLabels", true);
    },
    nbOfNights() {
      const { checkIn, checkOut } = this.date;
      if (checkIn && checkOut) {
        return moment(checkOut, "DD MMM YYYY").diff(
          moment(checkIn, "DD MMM YYYY"),
          "days"
        );
      }
      return 0;
    },
  },
  methods: {
    formatAddressText: (address) => formatAddressText(address),
    openProperty(id) {
      this.$emit("openProperty", id);
    },
    ratingValue(value) {
      return parseFloat(value).toFixed(1);
    },
    getDistanceInKm(lat, long) {
      const { latitude, longitude } = this.location;
      const toRad = (angle) => (angle * Math.PI) / 180;

      const dLat = toRad(latitude - lat);
      const dLon = toRad(longitude - long);

      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat)) *
          Math.cos(toRad(latitude)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);

      const distanceKm = 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distanceMeters = distanceKm * 1000;

      const formattedDistance =
        distanceMeters < 1000
          ? `${distanceMeters.toFixed(0)} m`
          : `${distanceKm.toFixed(1)} km`;

      return formattedDistance;
    },
    getRatingTranslationKey(score) {
      if (score >= 9.5 && score <= 10) {
        return "rating.exceptional";
      } else if (score >= 9 && score < 9.5) {
        return "rating.wonderful";
      } else if (score >= 8 && score < 9) {
        return "rating.veryGood";
      } else if (score >= 7 && score < 8) {
        return "rating.good";
      } else if (score >= 6 && score < 7) {
        return "rating.pleasant";
      } else if (score >= 5 && score < 6) {
        return "rating.reviewScore";
      } else if (score >= 4 && score < 5) {
        return "rating.passable";
      } else if (score >= 3 && score < 4) {
        return "rating.poor";
      } else if (score >= 2 && score < 3) {
        return "rating.veryPoor";
      } else if (score >= 1 && score < 2) {
        return "rating.disappointing";
      } else {
        return "rating.noRating";
      }
    },
    getTranslatedRating(score) {
      const key = this.getRatingTranslationKey(score);
      return this.$t(key);
    },
  },
};
</script>
